<template>
  <div class="home">
    <div class="welcomecont">
      <div class="titlehome">
        <img
          class="boat"
          src="../assets/images/headline-boat.svg"
        >
        <h1>Mennyire vagy <br>XXI. századi vezető?</h1>
        <!--<div class="subtitle">Tudd meg és nyerj!</div>-->
      </div>
      <!--<div class="winhome">
        <img
          v-on:click="modal"
          class="nyeremeny"
          src="../assets/images/nyeremenyek.png"
        >
      </div>-->
      <router-link
        to="/bevezeto"
        tag="button"
        class="btn"
      >Kezdjük</router-link>
    </div>
    <!--<div
      class="modalcont"
      v-show="showmodal"
    >
      <div class="modal">
        <simplebar data-simplebar-auto-hide="false">
          <div class="nytitle">Nyeremények:</div>
          <ul>
            <li>
              <p class="line1">2 fő részére szóló retúr repülőjegy a Qatar Airways által üzemeltetett bármely desztinációra 600.000 Ft értékben **</p>
              <p class="line2">** A repülőjegyek budapesti indulással használhatók fel a Qatar Airways járatain economy osztályon atársaság által repült desztinációk bármelyikére. Az együtt utazó személyt, illetve az úti célt a nyertes jogosult meghatározni a Qatar Airways kínálatában szereplő desztinációkat figyelembe véve. A repülőjegyek kiállítására - a nyertes vonatkozó döntése szerint - 2019. szeptember 30-ig kerülhet sor azzal, hogy a tényleges utazás 2019. december 16-áig bezárólag valósítható meg. A repülőtéri illeték a nyertest terheli, amelynek mértéke függ a kiválasztott desztinációtól.</p>
            </li>
            <li>
              <p class="line1">1 db, egyéves MVÜK tagság, amennyiben a nyertes megfelel a kritériumoknak *</p>
              <p class="line2">* Amennyiben 100 Millió Ft feletti éves nettó árbevételű cég vezetője az illető.</p>
            </li>
            <li>
              <p class="line1">1 db, a Profi Generál Kft felajánlásából exkluzív VIP élménylövészet csomag 6 fő részére 300.000 Ft értékben a Budapest Shooting Lőtéren.</p>
            </li>
          </ul>
        </simplebar>
      </div>
    </div>-->
    <!--<div
      class="wintext"
      v-on:click="modal"
    >
      <span v-if="!showmodal">*Nyereméyek pontos részletei</span>
      <span v-if="showmodal">Bezárás</span>
    </div>-->
  </div>
</template>

<style scoped>
.home {
  min-height: calc(100vh - 65px);
}
.subtitle {
  font-size: 30px;
  font-weight: 400;
  margin: 20px 0 20px 0;
  text-transform: uppercase;
}
h1,
.subtitle {
  text-align: center;
}
.welcomecont {
  display: grid;
  margin: 0 auto;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  justify-content: center;
  align-items: center;
  padding: 60px 0 10px 0;
  width: calc(100vw - 250px);
}
.titlehome {
  grid-column: 1/2;
  grid-row: 1/2;
  position: relative;
}
.btn {
  justify-self: center;
  grid-column: 1/2;
  grid-row: 2/3;
  margin-top: 60px;
}
.boat {
  position: absolute;
  z-index: -1;
  width: 60%;
  left: 18%;
  top: -10%;
}
.wintext {
  position: absolute;
  bottom: 15px;
  right: 30px;
  color: #fff;
  cursor: pointer;
}
.modalcont {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
}
.modal {
  background-color: #fff;
  width: calc(100vw - 85px);
  position: absolute;
  right: 30px;
  bottom: 50px;
  border-radius: 22px;
  padding: 15px;
  max-height: calc(100vh - 85px);
}
.modal:after {
  content: "";
  display: block;
  bottom: -15px;
  right: 25px;
  border: solid transparent;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 255, 255, 0);
  border-top-color: #ffffff;
  border-width: 16px 0 0px 30px;
}
.nytitle {
  font-family: "Abril Fatface", cursive;
  font-size: 24px;
}
.line1 {
  margin-block-start: 0;
  margin-block-end: 5px;
}
.line2 {
  margin-block-start: 0;
  margin-block-end: 0;
  font-style: italic;
}
li {
  margin-bottom: 15px;
}
.nyeremeny {
  cursor: pointer;
}
@media screen and (max-width: 1400px) {
  .nyeremeny {
    width: 320px;
  }
}
@media screen and (max-width: 1300px) {
  .nyeremeny {
    width: 280px;
  }
}
@media screen and (max-width: 1100px) {
  .welcomecont {
    width: calc(100vw - 60px);
  }
  h1 {
    font-size: 50px;
  }
}
@media screen and (max-width: 900px) {
  .nyeremeny {
    width: 240px;
  }
  h1 {
    font-size: 40px;
  }
}
@media screen and (max-width: 767px) {
  .subtitle {
    font-size: 26px;
    margin: 10px 0 0 0;
  }
  .welcomecont {
    grid-template-columns: auto;
    grid-template-rows: auto auto;
    justify-content: center;
    grid-row-gap: 20px;
    padding: 30px 0 10px 0;
  }
  .titlehome {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .btn {
    grid-column: 1/2;
    grid-row: 3/4;
    margin-top: 20px;
  }
  .modal {
    max-height: calc(100vh - 160px);
    position: fixed;
  }
  .wintext.open {
    position: fixed;
  }
}
@media screen and (max-width: 550px) {
  .welcomecont {
    padding: 30px 0 40px 0;
  }
}
@media screen and (max-width: 450px) {
  h1 {
    font-size: 34px;
  }
  .subtitle {
    font-size: 24px;
  }
  .home {
    min-height: calc(100vh - 93px);
  }
  .boat {
    width: 85%;
    left: 4%;
    top: -8%;
  }
  .wintext {
    bottom: 10px;
    font-size: 15px;
  }
  .nytitle {
    font-size: 22px;
  }
  .modal p {
    font-size: 14px;
  }
}
</style>
<style>
.home .simplebar-scrollbar:before {
  background: #42475c;
}
.simplebar-content {
  padding-right: 30px !important;
}
.home .simplebar-scrollbar:before {
  opacity: 0.5;
}
</style>
<script>
// @ is an alias to /src
// import simplebar from 'simplebar-vue'
// import 'simplebar/dist/simplebar.min.css'

export default {
  name: 'home',
  components: {
    // simplebar
  },
  data: function () {
    return {
      showmodal: false
    }
  },
  methods: {
    initBGmove () {
      this.$store.state.bgCurrent = 0
      const bgIMG = document.querySelector('.backgroundimg')
      bgIMG.setAttribute('style', 'transform: translateX(' + this.$store.state.bgCurrent + 'px)')
    },
    /* modal () {
      const modalOpener = document.querySelector('.wintext')
      const header = document.querySelector('.headercomponent')
      if (!this.showmodal) {
        this.showmodal = true
        modalOpener.classList.toggle('open')
        header.setAttribute('style', 'z-index: 1')
      } else {
        this.showmodal = false
        modalOpener.classList.toggle('open')
        header.setAttribute('style', 'z-index: 2')
      }
    } */
    getBrowser () {
      const browser = navigator.userAgent
      if (browser.indexOf('Firefox/66') > -1) {
        const backgroundimg = document.querySelector('.backgroundimg')
        backgroundimg.setAttribute('style', 'height: 50%')
      }
    }
  },
  mounted () {
    this.getBrowser()
    this.initBGmove()
  }
}
</script>
